import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('usuarios');
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedAd, setSelectedAd] = useState<any>(null);
  const [showAdModal, setShowAdModal] = useState(false);

  // Datos de ejemplo del administrador
  const admin = {
    name: 'María González',
    email: 'admin@futbolcanchas.com',
    role: 'Administrador',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20mexican%20female%20administrator%20profile%20photo%2C%20confident%20business%20woman%2C%20formal%20attire%2C%20clean%20background%2C%20executive%20headshot&width=150&height=150&seq=admin-avatar&orientation=squarish'
  };

  const [users, setUsers] = useState([
    {
      id: 1,
      name: 'Juan Carlos López',
      email: 'juan.lopez@email.com',
      phone: '+52 55 1234 5678',
      city: 'Ciudad de México',
      state: 'Ciudad de México',
      company: 'Deportes López S.A. de C.V.',
      companyAddress: 'Av. Insurgentes Sur 1234, Col. Del Valle',
      taxId: 'DLO901123ABC',
      joinDate: '2024-01-15',
      publications: 3,
      status: true,
      avatar: 'https://readdy.ai/api/search-image?query=mexican%20male%20user%20profile%20photo%2C%20casual%20friendly%20appearance%2C%20young%20adult%2C%20clean%20background&width=100&height=100&seq=user1&orientation=squarish'
    },
    {
      id: 2,
      name: 'Ana Martínez',
      email: 'ana.martinez@email.com',
      phone: '+52 55 9876 5432',
      city: 'Guadalajara',
      state: 'Jalisco',
      company: 'Arena Deportiva MX',
      companyAddress: 'Calle Juárez 567, Centro',
      taxId: 'ADM850612XYZ',
      joinDate: '2024-01-10',
      publications: 1,
      status: true,
      avatar: 'https://readdy.ai/api/search-image?query=mexican%20female%20user%20profile%20photo%2C%20friendly%20smile%2C%20young%20adult%2C%20casual%20clothing%2C%20clean%20background&width=100&height=100&seq=user2&orientation=squarish'
    },
    {
      id: 3,
      name: 'Carlos Ruiz',
      email: 'carlos.ruiz@email.com',
      phone: '+52 81 2468 1357',
      city: 'Monterrey',
      state: 'Nuevo León',
      company: 'Complejo Norte S.C.',
      companyAddress: 'Av. González 890, San Pedro',
      taxId: 'CNS770304DEF',
      joinDate: '2024-01-08',
      publications: 5,
      status: false,
      avatar: 'https://readdy.ai/api/search-image?query=mexican%20male%20user%20profile%20photo%2C%20middle%20aged%2C%20business%20casual%2C%20professional%20appearance&width=100&height=100&seq=user3&orientation=squarish'
    },
    {
      id: 4,
      name: 'Laura Sánchez',
      email: 'laura.sanchez@email.com',
      phone: '+52 33 5555 4444',
      city: 'Puebla',
      state: 'Puebla',
      company: 'Deportivo Poblano',
      companyAddress: 'Blvd. 5 de Mayo 321, Angelópolis',
      taxId: 'DPO920815GHI',
      joinDate: '2024-01-05',
      publications: 2,
      status: true,
      avatar: 'https://readdy.ai/api/search-image?query=mexican%20female%20user%20profile%20photo%2C%20professional%20woman%2C%20friendly%20expression%2C%20business%20attire&width=100&height=100&seq=user4&orientation=squarish'
    }
  ]);

  const [advertisements, setAdvertisements] = useState([
    {
      id: 1,
      name: 'Cancha Los Tigres',
      owner: 'Juan Carlos López',
      location: 'Polanco, Ciudad de México',
      category: 'Fútbol 11',
      price: 800,
      status: 'pendiente',
      submittedDate: '2024-01-18',
      views: 0,
      image: 'https://readdy.ai/api/search-image?query=professional%20soccer%20field%20with%20green%20artificial%20turf%2C%20stadium%20lights%2C%20goal%20posts%2C%20modern%20sports%20facility&width=300&height=200&seq=ad1&orientation=landscape'
    },
    {
      id: 2,
      name: 'Arena Deportiva Premium',
      owner: 'Ana Martínez',
      location: 'Santa Fe, Ciudad de México',
      category: 'Futsal',
      price: 450,
      status: 'aprobado',
      submittedDate: '2024-01-16',
      views: 89,
      image: 'https://readdy.ai/api/search-image?query=indoor%20futsal%20court%20with%20wooden%20floor%2C%20professional%20indoor%20soccer%20facility%2C%20bright%20lighting&width=300&height=200&seq=ad2&orientation=landscape'
    },
    {
      id: 3,
      name: 'Campo Verde',
      owner: 'Carlos Ruiz',
      location: 'Coyoacán, Ciudad de México',
      category: 'Fútbol 7',
      price: 350,
      status: 'rechazado',
      submittedDate: '2024-01-14',
      views: 0,
      image: 'https://readdy.ai/api/search-image?query=soccer%20field%20number%207%20artificial%20grass%2C%20smaller%20football%20pitch%2C%20goal%20posts%2C%20modern%20sports%20center&width=300&height=200&seq=ad3&orientation=landscape'
    },
    {
      id: 4,
      name: 'Complejo Deportivo Norte',
      owner: 'Laura Sánchez',
      location: 'Puebla, Puebla',
      category: 'Fútbol 5',
      price: 280,
      status: 'aprobado',
      submittedDate: '2024-01-12',
      views: 156,
      image: 'https://readdy.ai/api/search-image?query=small%20soccer%20field%20for%205%20players%2C%20artificial%20turf%2C%20enclosed%20court%20with%20walls%2C%20modern%20sports%20facility&width=300&height=200&seq=ad4&orientation=landscape'
    },
    {
      id: 5,
      name: 'Estadio Municipal',
      owner: 'Juan Carlos López',
      location: 'Naucalpan, Estado de México',
      category: 'Fútbol 11',
      price: 950,
      status: 'pendiente',
      submittedDate: '2024-01-19',
      views: 0,
      image: 'https://readdy.ai/api/search-image?query=municipal%20soccer%20stadium%20with%20professional%20grass%2C%20large%20football%20field%20with%20bleachers&width=300&height=200&seq=ad5&orientation=landscape'
    }
  ]);

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'aprobado': return 'text-green-600 bg-green-50';
      case 'pendiente': return 'text-yellow-600 bg-yellow-50';
      case 'rechazado': return 'text-red-600 bg-red-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  const handleApproveAd = (adId: number) => {
    setAdvertisements(prev =>
      prev.map(ad =>
        ad.id === adId ? { ...ad, status: 'aprobado' } : ad
      )
    );
  };

  const handleRejectAd = (adId: number) => {
    setAdvertisements(prev =>
      prev.map(ad =>
        ad.id === adId ? { ...ad, status: 'rechazado' } : ad
      )
    );
  };

  const handleToggleUser = (userId: number) => {
    setUsers(prev =>
      prev.map(user =>
        user.id === userId ? { ...user, status: !user.status } : user
      )
    );
  };

  const handleViewProfile = (user: any) => {
    setSelectedUser(user);
    setShowUserModal(true);
  };

  const closeUserModal = () => {
    setShowUserModal(false);
    setSelectedUser(null);
  };

  const handleViewAdDetails = (ad: any) => {
    setSelectedAd(ad);
    setShowAdModal(true);
  };

  const closeAdModal = () => {
    setShowAdModal(false);
    setSelectedAd(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <Link to="/" className="flex items-center">
                <img
                  src="https://storage.readdy-site.link/project_files/84f75d7c-5aa3-41e4-b7ad-dd29b3b984c6/838cdbab-d32d-4b26-b12c-15bffc18506a_poktapok_v1_sin-fondo.png"
                  alt="PokTaPok"
                  className="h-12 w-auto object-contain cursor-pointer"
                />
              </Link>
              <div className="h-6 w-px bg-gray-300"></div>
              <h1 className="text-xl font-bold text-gray-800">Panel de Administración</h1>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <img
                  src={admin.avatar}
                  alt={admin.name}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <div className="hidden md:block">
                  <div className="text-gray-700 font-medium">{admin.name}</div>
                  <div className="text-xs text-gray-500">{admin.role}</div>
                </div>
              </div>
              <Button variant="outline" size="sm" className="whitespace-nowrap">
                <i className="ri-logout-line mr-2"></i>
                Cerrar Sesión
              </Button>
            </div>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <Card className="p-6">
              <div className="text-center mb-6">
                <img
                  src={admin.avatar}
                  alt={admin.name}
                  className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="font-bold text-lg text-gray-800">{admin.name}</h3>
                <p className="text-gray-600 text-sm">{admin.role}</p>
              </div>

              <nav className="space-y-2">
                <button
                  onClick={() => setActiveTab('usuarios')}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors cursor-pointer ${
                    activeTab === 'usuarios' ? 'bg-gradient-to-r from-green-600 to-green-700 text-white' : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-user-line"></i>
                  <span>Ver Usuarios</span>
                </button>
                <button
                  onClick={() => setActiveTab('anuncios')}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors cursor-pointer ${
                    activeTab === 'anuncios' ? 'bg-gradient-to-r from-green-600 to-green-700 text-white' : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-advertisement-line"></i>
                  <span>Ver Anuncios</span>
                </button>
              </nav>
            </Card>

            {/* Statistics Card */}
            <Card className="p-6 mt-6">
              <h3 className="text-lg font-bold text-gray-800 mb-4">Estadísticas</h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Total Usuarios</span>
                  <span className="font-bold text-gray-800">{users.length}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Anuncios Activos</span>
                  <span className="font-bold text-green-600">{advertisements.filter(ad => ad.status === 'aprobado').length}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Pendientes</span>
                  <span className="font-bold text-yellow-600">{advertisements.filter(ad => ad.status === 'pendiente').length}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Rechazados</span>
                  <span className="font-bold text-red-600">{advertisements.filter(ad => ad.status === 'rechazado').length}</span>
                </div>
              </div>
            </Card>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            {/* Ver Usuarios */}
            {activeTab === 'usuarios' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-800">Gestión de Usuarios</h2>
                  <div className="flex items-center space-x-4">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Buscar usuarios..."
                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                      />
                      <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  {users.map((user) => (
                    <Card key={user.id} className="p-6 border-2 border-red-200">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          <img
                            src={user.avatar}
                            alt={user.name}
                            className="w-16 h-16 rounded-full object-cover"
                          />
                          <div>
                            <h3 className="font-bold text-lg text-gray-800">{user.name}</h3>
                            <p className="text-gray-600">{user.email}</p>
                            <p className="text-sm text-gray-500">{user.phone}</p>
                            <p className="text-sm text-gray-5">{user.city}, {user.state}</p>
                            <p className="text-sm text-gray-500 font-medium">{user.company}</p>
                            <p className="text-xs text-gray-400">RFC: {user.taxId}</p>
                          </div>
                        </div>

                        <div className="text-right">
                          <div className="flex items-center space-x-4 mb-2">
                            {/* Switch Toggle */}
                            <div className="flex items-center space-x-2">
                              <span className={`text-sm font-medium ${user.status ? 'text-green-600' : 'text-red-600'}`}>
                                {user.status ? 'Activo' : 'Suspendido'}
                              </span>
                              <button
                                onClick={() => handleToggleUser(user.id)}
                                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                                  user.status ? 'bg-green-600' : 'bg-gray-300'
                                }`}
                              >
                                <span
                                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
                                    user.status ? 'translate-x-6' : 'translate-x-1'
                                  }`}
                                />
                              </button>
                            </div>
                          </div>
                          <div className="text-sm text-gray-600 mb-2">
                            <span>{user.publications} publicaciones</span>
                            <span className="mx-2">•</span>
                            <span>Desde {user.joinDate}</span>
                          </div>
                          <div className="flex space-x-2">
                            <button
                              onClick={() => handleViewProfile(user)}
                              className="font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-3 py-1.5 text-sm"
                            >
                              Ver Perfil
                            </button>
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>
            )}

            {/* Ver Anuncios */}
            {activeTab === 'anuncios' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-800">Gestión de Anuncios</h2>
                  <div className="flex items-center space-x-4">
                    <select className="border border-gray-300 rounded px-3 py-2 text-sm pr-8">
                      <option value="">Todos los estados</option>
                      <option value="pendiente">Pendientes</option>
                      <option value="aprobado">Aprobados</option>
                      <option value="rechazado">Rechazados</option>
                    </select>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Buscar anuncios..."
                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                      />
                      <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {advertisements.map((ad) => (
                    <Card key={ad.id} className="overflow-hidden">
                      <img
                        src={ad.image}
                        alt={ad.name}
                        className="w-full h-48 object-cover object-top"
                      />
                      <div className="p-4">
                        <div className="flex items-start justify-between mb-2">
                          <h3 className="font-bold text-lg">{ad.name}</h3>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(ad.status)}`}>
                            {ad.status.charAt(0).toUpperCase() + ad.status.slice(1)}
                          </span>
                        </div>

                        <div className="text-sm text-gray-600 mb-2">
                          <div className="flex items-center mb-1">
                            <i className="ri-user-line mr-1"></i>
                            <span>Propietario: {ad.owner}</span>
                          </div>
                          <div className="flex items-center mb-1">
                            <i className="ri-map-pin-line mr-1"></i>
                            <span>{ad.location}</span>
                          </div>
                          <div className="flex items-center">
                            <i className="ri-calendar-line mr-1"></i>
                            <span>Enviado: {ad.submittedDate}</span>
                          </div>
                        </div>

                        <div className="flex items-center justify-between mb-3">
                          <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
                            {ad.category}
                          </span>
                          <span className="text-green-600 font-bold">${ad.price}/hora</span>
                        </div>

                        <div className="text-center mb-4">
                          <span className="text-sm text-gray-600">{ad.views} visualizaciones</span>
                        </div>

                        <div className="space-y-2">
                          <Button 
                            variant="outline" 
                            size="sm" 
                            className="w-full whitespace-nowrap"
                            onClick={() => handleViewAdDetails(ad)}
                          >
                            Ver Detalles Completos
                          </Button>

                          {ad.status === 'pendiente' && (
                            <div className="flex space-x-2">
                              <Button
                                size="sm"
                                onClick={() => handleApproveAd(ad.id)}
                                className="flex-1 bg-green-600 hover:bg-green-700 whitespace-nowrap"
                              >
                                <i className="ri-check-line mr-1"></i>
                                Aprobar
                              </Button>
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => handleRejectAd(ad.id)}
                                className="flex-1 text-red-600 border-red-600 hover:bg-red-50 whitespace-nowrap"
                              >
                                <i className="ri-close-line mr-1"></i>
                                Rechazar
                              </Button>
                            </div>
                          )}

                          {ad.status === 'aprobado' && (
                            <Button
                              variant="outline"
                              size="sm"
                              className="w-full text-yellow-600 border-yellow-600 hover:bg-yellow-50 whitespace-nowrap"
                            >
                              <i className="ri-pause-line mr-1"></i>
                              Pausar Anuncio
                            </Button>
                          )}

                          {ad.status === 'rechazado' && (
                            <Button
                              size="sm"
                              onClick={() => handleApproveAd(ad.id)}
                              className="w-full bg-green-600 hover:bg-green-700 whitespace-nowrap"
                            >
                              <i className="ri-refresh-line mr-1"></i>
                              Reactivar
                            </Button>
                          )}
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal Ver Perfil Usuario */}
      {showUserModal && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border-2 border-red-300">
            {/* Header del Modal */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-800">Perfil del Usuario</h2>
              <button
                onClick={closeUserModal}
                className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            {/* Contenido del Modal */}
            <div className="p-6">
              {/* Información Personal */}
              <div className="flex items-center space-x-6 mb-8">
                <img
                  src={selectedUser.avatar}
                  alt={selectedUser.name}
                  className="w-24 h-24 rounded-full object-cover border-4 border-gray-200"
                />
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">{selectedUser.name}</h3>
                  <div className="flex items-center space-x-4">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                      selectedUser.status
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {selectedUser.status ? 'Cuenta Activa' : 'Cuenta Suspendida'}
                    </span>
                    <span className="text-gray-500 text-sm">
                      Miembro desde {selectedUser.joinDate}
                    </span>
                  </div>
                </div>
              </div>

              {/* Información de Contacto */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <Card className="p-4 border border-gray-200">
                  <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                    <i className="ri-contacts-line mr-2 text-blue-600"></i>
                    Información de Contacto
                  </h4>
                  <div className="space-y-3">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-gray-400"></i>
                      <span className="text-gray-700">{selectedUser.email}</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-phone-line mr-3 text-gray-400"></i>
                      <span className="text-gray-700">{selectedUser.phone}</span>
                    </div>
                    <div className="flex items-start">
                      <i className="ri-map-pin-line mr-3 text-gray-400 mt-1"></i>
                      <span className="text-gray-700">{selectedUser.city}, {selectedUser.state}</span>
                    </div>
                  </div>
                </Card>

                <Card className="p-4 border border-gray-200">
                  <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                    <i className="ri-building-line mr-2 text-green-600"></i>
                    Información Empresarial
                  </h4>
                  <div className="space-y-3">
                    <div>
                      <span className="text-sm text-gray-500">Empresa:</span>
                      <div className="font-medium text-gray-800">{selectedUser.company}</div>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">Dirección:</span>
                      <div className="text-gray-700 text-sm">{selectedUser.companyAddress}</div>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">RFC:</span>
                      <div className="font-mono text-gray-800">{selectedUser.taxId}</div>
                    </div>
                  </div>
                </Card>
              </div>

              {/* Estadísticas */}
              <Card className="p-4 border border-gray-200 mb-6">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <i className="ri-bar-chart-line mr-2 text-purple-600"></i>
                  Estadísticas de Actividad
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-600">{selectedUser.publications}</div>
                    <div className="text-sm text-gray-500">Publicaciones</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-green-600">
                      {advertisements.filter(ad => ad.owner === selectedUser.name && ad.status === 'aprobado').length}
                    </div>
                    <div className="text-sm text-gray-500">Aprobadas</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-yellow-600">
                      {advertisements.filter(ad => ad.owner === selectedUser.name && ad.status === 'pendiente').length}
                    </div>
                    <div className="text-sm text-gray-500">Pendientes</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-red-600">
                      {advertisements.filter(ad => ad.owner === selectedUser.name && ad.status === 'rechazado').length}
                    </div>
                    <div className="text-sm text-gray-500">Rechazadas</div>
                  </div>
                </div>
              </Card>

              {/* Publicaciones del Usuario */}
              <div className="mb-6">
                <h4 className="font-semibold text-gray-800 mb-4 flex items-center">
                  <i className="ri-advertisement-line mr-2 text-orange-600"></i>
                  Sus Publicaciones ({advertisements.filter(ad => ad.owner === selectedUser.name).length})
                </h4>
                <div className="space-y-3 max-h-48 overflow-y-auto">
                  {advertisements
                    .filter(ad => ad.owner === selectedUser.name)
                    .map(ad => (
                      <div key={ad.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border">
                        <div className="flex items-center space-x-3">
                          <img
                            src={ad.image}
                            alt={ad.name}
                            className="w-12 h-12 rounded-lg object-cover"
                          />
                          <div>
                            <div className="font-medium text-gray-800">{ad.name}</div>
                            <div className="text-sm text-gray-500">{ad.location}</div>
                          </div>
                        </div>
                        <div className="text-right">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(ad.status)}`}>
                            {ad.status.charAt(0).toUpperCase() + ad.status.slice(1)}
                          </span>
                          <div className="text-sm text-gray-500 mt-1">${ad.price}/hora</div>
                        </div>
                      </div>
                    ))}
                  {advertisements.filter(ad => ad.owner === selectedUser.name).length === 0 && (
                    <div className="text-center py-8 text-gray-500">
                      <i className="ri-file-list-line text-4xl mb-2"></i>
                      <p>No tiene publicaciones registradas</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Acciones del Modal */}
              <div className="flex space-x-3 pt-4 border-t border-gray-200">
                <Button
                  onClick={() => handleToggleUser(selectedUser.id)}
                  className={`flex-1 whitespace-nowrap ${
                    selectedUser.status
                      ? 'bg-red-600 hover:bg-red-700 text-white'
                      : 'bg-green-600 hover:bg-green-700 text-white'
                  }`}
                >
                  <i className={`mr-2 ${selectedUser.status ? 'ri-user-forbid-line' : 'ri-user-line'}`}></i>
                  {selectedUser.status ? 'Suspender Usuario' : 'Activar Usuario'}
                </Button>
                <Button
                  variant="outline"
                  onClick={closeUserModal}
                  className="flex-1 whitespace-nowrap border-gray-300 text-gray-700 hover:bg-gray-50"
                >
                  Cerrar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Ver Detalles del Anuncio */}
      {showAdModal && selectedAd && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border-2 border-red-300">
            {/* Header del Modal */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <div className="flex items-center space-x-4">
                <h2 className="text-2xl font-bold text-gray-800">{selectedAd.name}</h2>
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(selectedAd.status)}`}>
                  {selectedAd.status.charAt(0).toUpperCase() + selectedAd.status.slice(1)}
                </span>
              </div>
              <button
                onClick={closeAdModal}
                className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            {/* Contenido del Modal */}
            <div className="p-6">
              {/* Imagen Principal */}
              <div className="mb-8">
                <img
                  src={selectedAd.image}
                  alt={selectedAd.name}
                  className="w-full h-64 rounded-lg object-cover object-top shadow-lg"
                />
              </div>

              {/* Información Básica */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <Card className="p-6 border border-gray-200">
                  <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
                    <i className="ri-information-line mr-2 text-blue-600"></i>
                    Información General
                  </h3>
                  <div className="space-y-4">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Nombre de la cancha:</span>
                      <span className="font-medium text-gray-800">{selectedAd.name}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Categoría:</span>
                      <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm font-medium">
                        {selectedAd.category}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Precio por hora:</span>
                      <span className="text-2xl font-bold text-green-600">${selectedAd.price}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Ubicación:</span>
                      <span className="font-medium text-gray-800">{selectedAd.location}</span>
                    </div>
                  </div>
                </Card>

                <Card className="p-6 border border-gray-200">
                  <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
                    <i className="ri-user-line mr-2 text-purple-600"></i>
                    Información del Propietario
                  </h3>
                  <div className="space-y-4">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Propietario:</span>
                      <span className="font-medium text-gray-800">{selectedAd.owner}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Fecha de envío:</span>
                      <span className="text-gray-700">{selectedAd.submittedDate}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Estado actual:</span>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(selectedAd.status)}`}>
                        {selectedAd.status.charAt(0).toUpperCase() + selectedAd.status.slice(1)}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Visualizaciones:</span>
                      <span className="font-medium text-gray-800">{selectedAd.views}</span>
                    </div>
                  </div>
                </Card>
              </div>

              {/* Detalles de la Cancha */}
              <Card className="p-6 border border-gray-200 mb-6">
                <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
                  <i className="ri-football-line mr-2 text-green-600"></i>
                  Detalles de la Cancha
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <i className="ri-ruler-line text-3xl text-blue-600 mb-2"></i>
                    <div className="font-semibold text-gray-800">Dimensiones</div>
                    <div className="text-sm text-gray-600">
                      {selectedAd.category === 'Fútbol 11' ? '100m x 64m' : 
                       selectedAd.category === 'Fútbol 7' ? '50m x 30m' :
                       selectedAd.category === 'Fútbol 5' ? '40m x 20m' :
                       selectedAd.category === 'Futsal' ? '40m x 20m' : '50m x 30m'}
                    </div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <i className="ri-grass-line text-3xl text-green-600 mb-2"></i>
                    <div className="font-semibold text-gray-800">Superficie</div>
                    <div className="text-sm text-gray-600">Césped Artificial</div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <i className="ri-lightbulb-line text-3xl text-yellow-600 mb-2"></i>
                    <div className="font-semibold text-gray-800">Iluminación</div>
                    <div className="text-sm text-gray-600">LED Profesional</div>
                  </div>
                </div>
              </Card>

              {/* Servicios Incluidos */}
              <Card className="p-6 border border-gray-200 mb-6">
                <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
                  <i className="ri-service-line mr-2 text-orange-600"></i>
                  Servicios y Amenidades
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="flex items-center space-x-2">
                    <i className="ri-parking-line text-green-600"></i>
                    <span className="text-sm text-gray-700">Estacionamiento</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-shirt-line text-green-600"></i>
                    <span className="text-sm text-gray-700">Vestidores</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-drop-line text-green-600"></i>
                    <span className="text-sm text-gray-700">Regaderas</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-shield-check-line text-green-600"></i>
                    <span className="text-sm text-gray-700">Seguridad</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-restaurant-line text-green-600"></i>
                    <span className="text-sm text-gray-700">Cafetería</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-wifi-line text-green-600"></i>
                    <span className="text-sm text-gray-700">WiFi Gratis</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-first-aid-kit-line text-green-600"></i>
                    <span className="text-sm text-gray-700">Botiquín</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-basketball-line text-green-600"></i>
                    <span className="text-sm text-gray-700">Equipo Rental</span>
                  </div>
                </div>
              </Card>

              {/* Horarios de Disponibilidad */}
              <Card className="p-6 border border-gray-200 mb-6">
                <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
                  <i className="ri-time-line mr-2 text-indigo-600"></i>
                  Horarios de Disponibilidad
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <h4 className="font-medium text-gray-800 mb-2">Lunes a Viernes</h4>
                    <div className="text-sm text-gray-600 space-y-1">
                      <div className="flex justify-between">
                        <span>Matutino:</span>
                        <span>06:00 - 12:00</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Vespertino:</span>
                        <span>14:00 - 18:00</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Nocturno:</span>
                        <span>19:00 - 23:00</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-800 mb-2">Sábados y Domingos</h4>
                    <div className="text-sm text-gray-600 space-y-1">
                      <div className="flex justify-between">
                        <span>Matutino:</span>
                        <span>07:00 - 12:00</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Vespertino:</span>
                        <span>13:00 - 18:00</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Nocturno:</span>
                        <span>19:00 - 22:00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>

              {/* Estadísticas de Rendimiento */}
              <Card className="p-6 border border-gray-200 mb-6">
                <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
                  <i className="ri-bar-chart-line mr-2 text-purple-600"></i>
                  Estadísticas de Rendimiento
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="text-center p-4 bg-blue-50 rounded-lg">
                    <div className="text-2xl font-bold text-blue-600">{selectedAd.views}</div>
                    <div className="text-sm text-gray-600">Visualizaciones</div>
                  </div>
                  <div className="text-center p-4 bg-green-50 rounded-lg">
                    <div className="text-2xl font-bold text-green-600">
                      {Math.floor(Math.random() * 50) + 10}
                    </div>
                    <div className="text-sm text-gray-600">Consultas</div>
                  </div>
                  <div className="text-center p-4 bg-yellow-50 rounded-lg">
                    <div className="text-2xl font-bold text-yellow-600">
                      {Math.floor(Math.random() * 20) + 5}
                    </div>
                    <div className="text-sm text-gray-600">Reservas</div>
                  </div>
                  <div className="text-center p-4 bg-purple-50 rounded-lg">
                    <div className="text-2xl font-bold text-purple-600">4.8</div>
                    <div className="text-sm text-gray-600">Calificación</div>
                  </div>
                </div>
              </Card>

              {/* Información de Contacto */}
              <Card className="p-6 border border-gray-200 mb-6">
                <h3 className="font-semibold text-lg text-gray-800 mb-4 flex items-center">
                  <i className="ri-contacts-line mr-2 text-red-600"></i>
                  Información de Contacto
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <i className="ri-phone-line text-gray-400"></i>
                      <span className="text-gray-700">+52 55 {Math.floor(Math.random() * 9000) + 1000} {Math.floor(Math.random() * 9000) + 1000}</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-whatsapp-line text-green-600"></i>
                      <span className="text-gray-700">WhatsApp disponible</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-mail-line text-gray-400"></i>
                      <span className="text-gray-700">{selectedAd.name.toLowerCase().replace(/\s+/g, '')}@email.com</span>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-start space-x-3">
                      <i className="ri-map-pin-line text-gray-400 mt-1"></i>
                      <div>
                        <div className="text-gray-700">{selectedAd.location}</div>
                        <div className="text-sm text-gray-500">Dirección completa disponible</div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-car-line text-gray-400"></i>
                      <span className="text-gray-700">Fácil acceso vehicular</span>
                    </div>
                  </div>
                </div>
              </Card>

              {/* Acciones del Modal */}
              <div className="flex space-x-3 pt-4 border-t border-gray-200">
                {selectedAd.status === 'pendiente' && (
                  <>
                    <Button
                      onClick={() => {
                        handleApproveAd(selectedAd.id);
                        closeAdModal();
                      }}
                      className="flex-1 bg-green-600 hover:bg-green-700 text-white whitespace-nowrap"
                    >
                      <i className="ri-check-line mr-2"></i>
                      Aprobar Anuncio
                    </Button>
                    <Button
                      onClick={() => {
                        handleRejectAd(selectedAd.id);
                        closeAdModal();
                      }}
                      className="flex-1 bg-red-600 hover:bg-red-700 text-white whitespace-nowrap"
                    >
                      <i className="ri-close-line mr-2"></i>
                      Rechazar Anuncio
                    </Button>
                  </>
                )}
                
                {selectedAd.status === 'aprobado' && (
                  <Button
                    onClick={() => {
                      handleRejectAd(selectedAd.id);
                      closeAdModal();
                    }}
                    className="flex-1 bg-yellow-600 hover:bg-yellow-700 text-white whitespace-nowrap"
                  >
                    <i className="ri-pause-line mr-2"></i>
                    Pausar Anuncio
                  </Button>
                )}

                {selectedAd.status === 'rechazado' && (
                  <Button
                    onClick={() => {
                      handleApproveAd(selectedAd.id);
                      closeAdModal();
                    }}
                    className="flex-1 bg-green-600 hover:bg-green-700 text-white whitespace-nowrap"
                  >
                    <i className="ri-refresh-line mr-2"></i>
                    Reactivar Anuncio
                  </Button>
                )}

                <Button
                  variant="outline"
                  onClick={closeAdModal}
                  className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-50 whitespace-nowrap"
                >
                  Cerrar
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
